var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Text from "../../../../Atoms/Text";
import { Box, Stack } from "@mui/material";
var MessageContent = function (_a) {
    var icon = _a.icon, title = _a.title, children = _a.children;
    return (_jsxs(Stack, __assign({ direction: "column", mx: [6, 12] }, { children: [icon && (_jsx(Box, __assign({ mb: 6, alignSelf: "center" }, { children: icon }))), _jsx(Text, __assign({ variant: "h4", emphasis: "medium_high", shade: "dark", category: "primary", sx: { textAlign: "center" } }, { children: title })), children] })));
};
export default MessageContent;
